<template>
  <div
      id="patientListDetails"
      :class="noti ? 'scroll_unset' : ''"
      class="contents relative"
      style="scroll-behavior: smooth;"
  >
    <div id="sectionHome">
      <div
          style="z-index:1; position: absolute; padding-top: 30px; right: 30px; cursor: pointer;"
          @click="handleClick(0)"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path v-if="open[0] === true" d="M18.7025 14.2959L12.7025 8.29027C12.3125 7.89991 11.6825 7.89991 11.2925 8.29027L5.2925 14.2959C4.9025 14.6863 4.9025 15.3169 5.2925 15.7072C5.4925 15.9074 5.7425 15.9975 6.0025 15.9975C6.2625 15.9975 6.5125 15.8974 6.7125 15.7072L12.0025 10.4123L17.2925 15.7072C17.4925 15.9074 17.7425 15.9975 18.0025 15.9975C18.2625 15.9975 18.5125 15.8974 18.7125 15.7072C19.0925 15.3269 19.0925 14.6863 18.7025 14.2959Z" fill="#201F1E"/>
          <path v-else d="M18.7047 8.29027C18.3143 7.89991 17.6838 7.89991 17.2934 8.29027L11.9987 13.5852L6.70401 8.29027C6.31366 7.89991 5.68311 7.89991 5.29276 8.29027C4.90241 8.68064 4.90241 9.31123 5.29276 9.7016L11.2981 15.7072C11.4983 15.9074 11.7485 15.9975 12.0087 15.9975C12.269 15.9975 12.5192 15.8974 12.7194 15.7072L18.7247 9.7016C19.095 9.32124 19.095 8.68064 18.7047 8.29027Z" fill="#201F1E"/>
        </svg>
      </div>
      <HeadArea
          v-if="open[0] === true"
          :patientTotalInfo="patientTotalInfo"
      />
      <Dummy
          v-else
          :title="`${$t('patients.name')} : ${patientTotalInfo.patientInfo.patientInfoName}`"
      />
    </div>

    <div>
      <div
          style="z-index:1; position: absolute; padding-top: 30px; right: 30px; cursor: pointer;"
          @click="handleClick(1)"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path v-if="open[1] === true" d="M18.7025 14.2959L12.7025 8.29027C12.3125 7.89991 11.6825 7.89991 11.2925 8.29027L5.2925 14.2959C4.9025 14.6863 4.9025 15.3169 5.2925 15.7072C5.4925 15.9074 5.7425 15.9975 6.0025 15.9975C6.2625 15.9975 6.5125 15.8974 6.7125 15.7072L12.0025 10.4123L17.2925 15.7072C17.4925 15.9074 17.7425 15.9975 18.0025 15.9975C18.2625 15.9975 18.5125 15.8974 18.7125 15.7072C19.0925 15.3269 19.0925 14.6863 18.7025 14.2959Z" fill="#201F1E"/>
          <path v-else d="M18.7047 8.29027C18.3143 7.89991 17.6838 7.89991 17.2934 8.29027L11.9987 13.5852L6.70401 8.29027C6.31366 7.89991 5.68311 7.89991 5.29276 8.29027C4.90241 8.68064 4.90241 9.31123 5.29276 9.7016L11.2981 15.7072C11.4983 15.9074 11.7485 15.9975 12.0087 15.9975C12.269 15.9975 12.5192 15.8974 12.7194 15.7072L18.7247 9.7016C19.095 9.32124 19.095 8.68064 18.7047 8.29027Z" fill="#201F1E"/>
        </svg>
      </div>
      <Home
          v-if="open[1] === true"
          :patientInfoProps="patientTotalInfo"
      />
      <Dummy
          v-else
          :title="$t( 'report.rom_change_monitoring' )"
      />
    </div>

    <Info
        id="sectionInfo"
        :patientInfoProps="patientTotalInfo"
    />
    <Note
        id="sectionNote"
        :patientInfoProps="patientTotalInfo"
    />
    <Remote
        id="sectionRemote"
        :patientInfoProps="patientTotalInfo"
    />
    <Rehab
        id="sectionRehab"
        :patientInfoProps="patientTotalInfo"
    />
    <div id="sectionHistory">
      <div
          style="z-index:1; position: absolute; padding-top: 30px; right: 30px; cursor: pointer;"
          @click="handleClick(2)"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path v-if="open[2] === true" d="M18.7025 14.2959L12.7025 8.29027C12.3125 7.89991 11.6825 7.89991 11.2925 8.29027L5.2925 14.2959C4.9025 14.6863 4.9025 15.3169 5.2925 15.7072C5.4925 15.9074 5.7425 15.9975 6.0025 15.9975C6.2625 15.9975 6.5125 15.8974 6.7125 15.7072L12.0025 10.4123L17.2925 15.7072C17.4925 15.9074 17.7425 15.9975 18.0025 15.9975C18.2625 15.9975 18.5125 15.8974 18.7125 15.7072C19.0925 15.3269 19.0925 14.6863 18.7025 14.2959Z" fill="#201F1E"/>
          <path v-else d="M18.7047 8.29027C18.3143 7.89991 17.6838 7.89991 17.2934 8.29027L11.9987 13.5852L6.70401 8.29027C6.31366 7.89991 5.68311 7.89991 5.29276 8.29027C4.90241 8.68064 4.90241 9.31123 5.29276 9.7016L11.2981 15.7072C11.4983 15.9074 11.7485 15.9975 12.0087 15.9975C12.269 15.9975 12.5192 15.8974 12.7194 15.7072L18.7247 9.7016C19.095 9.32124 19.095 8.68064 18.7047 8.29027Z" fill="#201F1E"/>
        </svg>
      </div>
      <History
          v-if="open[2] === true"
          :patientInfoProps="patientTotalInfo"
      />
      <Dummy
          v-else
          :title="$t('patient.rehabilitation_history')"
      />
    </div>
    <Report
        id="sectionReport"
        :patientInfoProps="patientTotalInfo"
    />
    <NotificationModal
        @hideNoti="hideNoti"
        @showNoti="showNoti"
    />
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions,
} from 'vuex'

export default {
  name: 'myPatient',
  components: {
    Dummy: () => import('./dummy/index'),
    HeadArea: () => import('./headArea/index'),
    NotificationModal: () => import('@/components/modal/notification'),
    Info: () => import('@/components/body/myPatient/info'),
    Home: () => import('@/components/body/myPatient/report/reportItem/romChangeMonitoringGraph'),
    Note: () => import('@/components/body/myPatient/note'),
    History: () => import('@/components/body/myPatient/history/index'),
    Remote: () => import('@/components/body/myPatient/remote/index'),
    Rehab: () => import('@/components/body/myPatient/rehab/index'),
    Report: () => import('@/components/body/myPatient/report/index'),
  },
  data() {
    return {
      noti: false,
      BodyComponents: 'Home',
      navIdxName: {
        0: 'home',
        1: 'info',
        2: 'note',
        3: 'remote',
        4: 'rehab',
        5: 'history',
        6: 'report',
      },
      patientTotalInfo: {
        seqPatient: '',
        patientEmail: '',
        patientStatus: '',
        patientInfo: {},
      },
      open: [
        true,
        true,
        true,
      ],
    }
  },
  methods: {
    ...mapGetters(['getSeqPatient', 'getNavMenu']),
    ...mapActions(['getPatientBySeqPatientFromPatientList', 'resetReport', 'inspectSelectPatient']),
    init() {
      const seqPatient = parseInt(this.$route.query.id);
      this.inspectSelectPatient(seqPatient);
      this.getPatientBySeqPatient(seqPatient)
      this.resetReport();
    },
    getPatientBySeqPatient(seqPatient) {
      this.getPatientBySeqPatientFromPatientList(seqPatient)
          .then(res => {
            if (res !== undefined)
              this.patientTotalInfo = JSON.parse(JSON.stringify(res));
            else
              this.$router.push('/patientList');
          })
          .catch(e => {
            console.error(e);
          })
    },
    hideNoti() {
      this.noti = false;
    },
    showNoti() {
      this.noti = true;
    },
    handleClick(index) {
      let tempData = JSON.parse(JSON.stringify(this.open));
      tempData[index] = !tempData[index]
      this.open = tempData;
    }
  },
  watch: {
    $route: {
      deep: true,
      handler(newVal, oldVal) {
        const newId = newVal.query?.id;
        const oldId = oldVal.query?.id;
        if (newId !== oldId) {
          this.init();
        }
      }
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setSeqPatient') {
        const seqPatient = state.seqPatient;
        this.getPatientBySeqPatient(seqPatient);
      }
    })
    this.init();
  },
  mounted() {
    // 페이지가 전환될때 마다 vuex에 menu를 갱신해 준다
    // this.$store.dispatch('changeNavMenu', 0); // 이 값을 초기화하지 않으면 다음 페이지에서 navMenu 값을 물고 감
    this.$store.dispatch('changeMainMenu', 1); // myPatient
  },
  beforeDestroy() {
    this.unsubscribe();
    this.resetReport()
  }
}
</script>
<style>
.contents {
  padding: 5px 5px;
  overflow-y: scroll;

  height: var(--app-height);

  display: flex;

  flex-direction: column;
  justify-content: stretch;
}
</style>